<template>
  <div aria-labelledby="promotion-barcode-title" role="region">
    <h2 id="promotion-barcode-title" class="sr-only">
      {{ $t('field.promotionBarcode') }}
    </h2>
    <Input
      id="promotionBarcode"
      :label="$t('field.promotionBarcode')"
      type="text"
      :value="value"
      :error="errorMessage"
      :required="true"
      @input="$emit('input', $event)"
      aria-labelledby="promotion-barcode-title"
    />

    <Button
      secondary
      icon-left="barcode"
      @click="onPromotionBarcodeSelected"
      :aria-label="$t('promotionBarcode.ariaLabel.add')"
      :aria-describedby="errorMessage ? 'promotionBarcode-error' : null"
      :disabled="!!errorMessage"
    >
      <span>{{ $t('promotionBarcode.button.add') }}</span>
    </Button>
  </div>
</template>

<script>
import Button from "@/components/actions/Button.vue";
import Input from "@/components/forms/Input.vue";

export default {
  components: {
    Input,
    Button,
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      errorMessage: null,
    };
  },
  methods: {
    onPromotionBarcodeSelected() {
      this.errorMessage = null;
      const barcode = (this.value || '').trim();
      if (barcode) {
        this.$emit('promotion-barcode-input', barcode);
      } else {
        this.errorMessage = this.$t('promotionBarcode.messages.error.invalid');
      }
    },
    close() {
      this.$emit('close');
    },
    handlePromotionBarcodeError(error) {
      this.errorMessage = error || this.$t('promotionBarcode.messages.error.invalid');
    },
  },
  mounted() {
    this.$root.$on('promotion-barcode-error', this.handlePromotionBarcodeError);
  },
  beforeDestroy() {
    this.$root.$off('promotion-barcode-error', this.handlePromotionBarcodeError);
  },
};
</script>
